export default __webpack_public_path__ + "static/media/ichra-logo.7d27c147.svg";